import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ToastrService as ToasterService } from 'ngx-toastr';

import { PermissionsService, PermissionValidator } from '@sd-portal/shared/permissions';

@Injectable({
  providedIn: 'root'
})
export class PermissionsGuard {
  constructor(
    private readonly permissionsService: PermissionsService,
    private readonly toasterService: ToasterService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.getPermissionStatus(route.data['permissions']);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.getPermissionStatus(childRoute.data['permissions']);
  }

  canLoad(route: Route): Observable<boolean> {
    const permissions = route && route.data ? route.data['permissions'] : null;
    return this.getPermissionStatus(permissions);
  }

  getPermissionStatus(permissions: PermissionValidator, isShowError = true): Observable<boolean> {
    const perms = new PermissionValidator(permissions ? permissions.policies : [], false);
    return this.permissionsService
      .currentUserCan(perms)
      .pipe(
        tap(permitted =>
          !permitted ? (isShowError ? this.toasterService.error('Access Denied') : null) : null
        )
      );
  }
}
